import { createFileRoute } from "@tanstack/react-router";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/dokumenty/ksef/$invoiceId")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(context.queryClient, "sidebar.dokumenty.ksef", location.pathname);
	},
	component: KsefInvoiceDetailPage,
});

function KsefInvoiceDetailPage() {
	const { invoiceId } = Route.useParams();
	return <div>KSeF Invoice: {invoiceId}</div>;
}
